import { FC, useEffect, useState } from "react";
import styles from "./PageTabPanel.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { Highlightable } from "../Highlight/Highlightable";
import { ActionPromptType } from "../../hooks/prompts";

export interface ITopButtonsTab {
    name: string;
    context?: string;
    value?: number;
    promptType?: ActionPromptType;
}

interface IPageTabPanelProps {
    tabs: ITopButtonsTab[];
}

export const PageTabPanel: FC<IPageTabPanelProps> = ({ tabs }) => {
    const [activeTab, setActiveTab] = useState(0);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === tabs[0].context)
            setActiveTab(0);
        else if (location.pathname === tabs[1].context)
            setActiveTab(1);
    }, [location, tabs]);

    const tabClickHandler = (index: number) => {
        if (tabs[index].context) {
            setActiveTab(index);
            const context = tabs[index].context!;
            navigate(context);
        }
    };

    const getTabName = (index: number) => index === 0 ? 'First' : 'Second';

    const getPromptType = (index: number) => {
        const prompt = tabs[index].promptType;
        if (index === activeTab || prompt === undefined)
            return ActionPromptType.NONE;
        
        return prompt;
    }

    return (
        <div className={styles.topBtnsBlock}>
            { tabs?.length &&
                tabs.map((tab, index) =>
                    <Highlightable
                        promptType={ getPromptType(index) }
                        highlightOffsetX="-20px"
                        highlightOffsetY="12px"
                        key={`tab-${tab.context}${index}`}
                    >
                        <button                            
                            className={`${styles[`btn${getTabName(index)}`]} ${activeTab === index ? styles.active : ""}`}
                            onClick={ () => tabClickHandler(index) }
                        >
                            <div>{ tab.name }</div>
                            { tab.value && <div className={styles.count}>{ tab.value }</div> }
                        </button>
                    </Highlightable>
                )
            }           
        </div>
    );
};